import { db } from '../utils/firebase';

export const getRobotics = async () => {
  const robotics = db.collection("contact").doc("robotics");
  const doc = await robotics.get();
  const { content } = doc.data();
  return { content };
}
export const getStudents = async () => {
  const students = db.collection("contact").doc("students");
  const doc = await students.get();
  const { content } = doc.data();
  return { content };
}
export const getLabTours = async () => {
  const tours = db.collection("contact").doc("labTours");
  const doc = await tours.get();
  const { content } = doc.data();
  return { content };
}
export const getVolunteers = async () => {
  const volunteers = db.collection("contact").doc("volunteers");
  const doc = await volunteers.get();
  const { content } = doc.data();
  return { content };
}
export const getAngels = async () => {
  const angels = db.collection("contact").doc("angels");
  const doc = await angels.get();
  const { content } = doc.data();
  return { content };
}
export const getBudgetContact = async () => {
  const budgetContact = db.collection("contact").doc("budgetContact");
  const doc = await budgetContact.get();
  const { content } = doc.data();
  return { content };
}
export const getContactInfo = async () => {
  const contactInfo = db.collection("contact").doc("contactInfo");
  const doc = await contactInfo.get();
  const { content } = doc.data();
  return { content };
}


//
// export const getIntroduction = async () => {
//   const introduction = db.collection("contact").doc("introduction");
//   const doc = await introduction.get();
//   const { image, content } = doc.data();
//
//   return { url: image, content };
// }
//
// export const getContactInfo = async () => {
//   const contact = db.collection("contact").doc("contact");
//   const doc = await contact.get();
//   const { location, number } = doc.data();
//
//   return { location, number };
// }
//
// export const getResearchers = async () => {
//   const researchers = db.collection("contact").doc("researchers");
//   // get title
//   const doc = await researchers.get();
//   const { title } = doc.data();
//   // get childrens
//   const children = [];
//   const querySnapshot = await researchers.collection("children").get();
//   querySnapshot.forEach(doc => {
//     const { subtitle, content, order } = doc.data();
//     children.push({ subtitle, content, order });
//   });
//
//   children.sort((a, b) => a.order - b.order)
//
//   return { title, researchers: children };
// }
//
// export const getParticipants = async () => {
//   const participants = db.collection("contact").doc("participants");
//   const doc = await participants.get();
//   const { content } = doc.data();
//
//   return { content };
//
// }
